import { Chip, ChipProps } from "@mui/material";
import { Status } from "helpers/assignment";

export interface AssignmentChipStatusProps extends ChipProps {
	label: Status;
}

export const AssignmentChipStatus = ({
	label,
	...props
}: AssignmentChipStatusProps): JSX.Element => (
	<Chip
		{...props}
		label={label}
		color={
			label === "Scheduled"
				? "warning"
				: label === "Completed"
				? "error"
				: "primary"
		}
	/>
);
